var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sitemap"},[_c('div',{staticClass:"container"},[_vm._l((_vm._tree[0].children),function(page){return [(_vm.allowed(page.meta))?_c('Page',{key:'sitemap_page_'+page.name,class:[{'private':!page.meta.public}],attrs:{"page":page,"language":_vm.language,"trace":page.name,"depth":1,"maxDepth":4}}):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }